export const getSDKVersion = () => '9.1.0';
//# sourceMappingURL=version.js.map